const RED = "#d32f2f";
const SPEC = [["CPU", "CPU"], ["MOTHERBOARD", "Motherboard"], ["COOLER", "Cooler"], ["RAM", "RAM"], ["GRAPHICS_CARD", "Graphics Card"],
  ["SSD1", "SSD1"], ["SSD2", "SSD2"], ["HDD", "HDD"], ["CHASSIS", "Chassis"], ["PSU", "PSU"], ["HEADPHONES", "Headphones"],
  ["MOUSE", "Mouse"], ["KEYBOARD", "Keyboard"], ["MONITOR", "Monitor"], ["FANS", "Fans"]];
export const PAYMENT_METHODS = ["Razor Pay", "UPI", "Bank Transfer", "Card", "Cash", "Bajaj EMI"];

const money = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const ddmmyyyy = (iso) => (iso ? iso.slice(0, 10).split("-").reverse().join("-") : "");

export const ocDefaults = (p) => ({
  orderDate: (p.createdAt || "").slice(0, 10), billingName: p.customerName || "", billingAddress: p.customerAddress || "",
  shippingName: p.customerName || "", shippingAddress: p.customerAddress || "", contactNo: p.customerPhone || "",
  gstNo: "", paymentMethod: "", shippingFee: 0, ...(p.ocDetails || {}),
});

export const ocFileName = (p) => {
  const d = new Date(ocDefaults(p).orderDate || p.createdAt || Date.now());
  return `Gamerz Nation Order Confirmation Q${Math.floor(((d.getMonth() + 9) % 12) / 3) + 1} ${d.getFullYear()} - ${p.customerName}`;
};

function Line({ k, v, tid }) {
  return <div className="text-[13px] leading-6"><b>{k}</b> <span data-testid={tid}>{v}</span></div>;
}

function SpecTable({ parts }) {
  const name = (cat) => parts.filter((x) => x.category === cat).map((x) => x.customPartName).join(", ");
  const extras = parts.filter((x) => !SPEC.some(([c]) => c === x.category));
  const rows = [...SPEC.map(([c, l]) => [l, name(c), c]), ...extras.map((x, i) => ["Accessory", x.customPartName, `EXTRA-${i}`])];
  return (
    <div className="mt-6 border-2" style={{ borderColor: RED }} data-testid="oc-specifications">
      <div className="px-4 py-2 font-bold text-white text-[14px]" style={{ background: RED }}>Specifications</div>
      <table className="w-full text-[12.5px]">
        <thead><tr className="border-b" style={{ borderColor: RED }}><th className="text-left px-4 py-1.5 w-44 font-bold">Category</th><th className="text-left px-4 py-1.5 font-bold">Component Name</th></tr></thead>
        <tbody>{rows.map(([l, v, c]) => (
          <tr key={c} className="border-b border-zinc-200 last:border-0"><td className="px-4 py-1.5 font-semibold">{l}</td><td className="px-4 py-1.5" data-testid={`oc-spec-${c}`}>{v}</td></tr>
        ))}</tbody>
      </table>
    </div>
  );
}

function Money({ total, fee, paid, method }) {
  const row = (l, v, tid, cls = "") => <div className={`flex justify-between py-1 ${cls}`}><span>{l}</span><span className="tabular-nums" data-testid={tid}>{v}</span></div>;
  return (
    <div className="mt-6">
      <div className="text-right text-[11.5px] italic mb-1">(Values Inclusive of 18% GST)</div>
      <div className="border-2" style={{ borderColor: RED }} data-testid="oc-financials">
        <div className="grid grid-cols-[1fr_auto] text-[13px] font-bold border-b px-4 py-2" style={{ borderColor: RED }}><span>Item</span><span>Price</span></div>
        <div className="grid grid-cols-[1fr_auto] text-[13px] px-4 py-2"><span className="font-semibold">Custom GamerzNation PC</span><span className="tabular-nums font-semibold" data-testid="oc-item-price">{money(total)}</span></div>
        <div className="ml-auto w-full sm:w-80 px-4 pb-2 text-[13px] border-t border-zinc-200">
          {row("Subtotal", money(total), "oc-subtotal")}
          {row("Shipping & handling", money(fee), "oc-shipping")}
          <div className="pt-1 font-semibold" data-testid="oc-payment-method">{method ? `Paid Via ${method}` : "Payment"}</div>
          {row("Amount Paid", money(paid), "oc-amount-paid")}
          {row("Amount Pending", money(Math.max(0, total + fee - paid)), "oc-amount-pending")}
        </div>
        <div className="flex justify-between items-center px-4 py-3 border-t-2 text-xl font-extrabold" style={{ borderColor: RED, color: RED, background: "#fdecea" }}>
          <span>Total Price:</span><span className="tabular-nums" data-testid="oc-total-price">{money(total + fee)}</span>
        </div>
      </div>
    </div>
  );
}

export function OrderConfirmationDoc({ p }) {
  const d = ocDefaults(p);
  const fee = +d.shippingFee || 0;
  return (
    <div className="print-area oc-doc bg-white text-zinc-900 w-full max-w-[820px] border-2 p-6 sm:p-10" style={{ borderColor: RED, fontFamily: "Arial, Helvetica, sans-serif" }} data-testid="order-confirmation-doc">
      <div className="flex items-start justify-between gap-6">
        <div className="text-[12px] leading-5 max-w-[480px]">
          <div className="text-[26px] font-extrabold tracking-wide leading-tight mb-1" style={{ color: RED }}>GAMERZ <span className="text-zinc-900">NATION</span></div>
          <div>401, 4th floor, Madhu Asha Building, Plot No. 3, Senapati Bapat Rd, Chattushringi, Gokhalenagar, Pune, Maharashtra 411016</div>
          <div>GSTN: 27BKIPA7717H1Z5</div>
          <div>Phone : 9545454941</div>
        </div>
        <img src="/brand/gn-logo.png" alt="Gamerz Nation" className="h-16 w-auto shrink-0" />
      </div>
      <h1 className="text-[26px] font-bold mt-7" style={{ color: RED }}>Order Confirmation</h1>
      <p className="text-[13px] mt-1">Thank you for your order. We’ll notify you once your order is ready to be shipped.</p>
      <p className="text-[13px] mt-2"><b>Date :</b> <span data-testid="oc-date">{ddmmyyyy(d.orderDate)}</span></p>
      <div className="mt-6" data-testid="oc-your-details">
        <div className="text-[15px] font-bold mb-1">Your Details</div>
        <Line k="Billing Name :" v={d.billingName} tid="oc-billing-name" />
        <Line k="Billing Address:" v={d.billingAddress} tid="oc-billing-address" />
        <Line k="Shipping Name :" v={d.shippingName} tid="oc-shipping-name" />
        <Line k="Shipping Address:" v={d.shippingAddress} tid="oc-shipping-address" />
        <Line k="Contact No. :" v={d.contactNo} tid="oc-contact" />
        <Line k="GST No:" v={d.gstNo || "N/A"} tid="oc-gst" />
      </div>
      <Money total={p.grandTotal} fee={fee} paid={p.advancePaidAmount} method={d.paymentMethod} />
      <SpecTable parts={p.parts || []} />
    </div>
  );
}
